<template>
  <div class="customerCaseDetail" :style="{maxHeight:height+'px'}">
    <div class="left">
      <div class="display_flex">
        <OssImg
          width="100%"
          :src="detail.caseOssUrl"
        />
      </div>
      <div class="title">{{detail.caseTitle}}</div>
      <div class="text">
        {{detail.caseRemark}}
      </div>
      <CommonBtn class="maria" title="获得高校实验室解决方案" @click="navTo('/solution/index')" style="margin-top: 1rem;width: 200px;">
          </CommonBtn>
    </div>
    <div class="right" v-html="detail.caseDetail"></div>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import CommonBtn from "@/components/commenBtn.vue";
import { navTo } from "@/utils/util";
import CaseApi from "@/api/caseApi";
import { useRoute } from "vue-router";
import { processRichTextImages } from "@/utils/hanldeRichText";
import { add } from "lodash";

const height = ref(0)
const route = useRoute();
const caseApi=new CaseApi();
const detail = ref({})
const id = ref(0)

onMounted(() => {
  id.value = route.query.id;
  //获取新闻详情
  getDetail(route.query.id);
  height.value = document.body.clientHeight - 80

  addCaseBrowse(id.value)
});

//获取列表
const getDetail = async(id)=>{
  let res = await caseApi.getCaseDetail({id:id})
  detail.value = res
  detail.value.caseDetail = removeBackgroundColorsFromRichText(res.caseDetail)
  detail.value.caseDetail  = await processRichTextImages(detail.value.caseDetail)
}

/**
 * 案例浏览量增加
 */
const addCaseBrowse = async(id)=>{
  await caseApi.addCaseBrowse(id)
}

function removeBackgroundColorsFromRichText(richText) {
  // 创建一个临时div来解析HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = richText;

  // 移除所有元素的style属性中的背景色
  const elementsWithStyle = tempDiv.querySelectorAll("[style]");
  elementsWithStyle.forEach((el) => {
    const style = el.getAttribute("style");
    const newStyle = style
      .replace(/background-color\s*:[^;]+;?/gi, "")
      .replace(/background\s*:[^;]+;?/gi, "")
      .trim();

    if (newStyle) {
      el.setAttribute("style", newStyle);
    } else {
      el.removeAttribute("style");
    }
  });

  // 移除内联样式中的背景色
  const allElements = tempDiv.querySelectorAll("*");
  allElements.forEach((el) => {
    if (el.style.backgroundColor || el.style.background) {
      el.style.backgroundColor = "";
      el.style.background = "";
    }
  });

  return tempDiv.innerHTML;
}
</script>

<style lang="scss" scoped>
.customerCaseDetail {
  display: flex;
  gap: 74px;
  font-family: "PingFang SC";
  .left {
    width: 30%;
    padding-top: 1rem;
    .title {
      color: #212121;
      font-weight: 500;
      font-size: 16px;
      margin: 16px 0px 8px 0px;
    }
    .text {
      text-align: justify;
      color: #888888;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .right{
    padding: 1rem;
    scrollbar-width: none;
    overflow-y: scroll;
  }
}
</style>
